import React from "react";
import { connect } from "react-redux";
import MMPLShipCard from "../MMPLShipCard";
import { getMDSearchlist } from "../../Actions/MDlistingAPI";
import "react-datepicker/dist/react-datepicker.css";
import {
  getMMPLIHMSearchlist,
  getMMPLMDocSearchlist,
  getMMPLPoValidationSearchlist,
  getMMPLShipCount,
  getMMPLShipSearch,
  getMMPLShortClosedSearchlist,
  addMMPLShortClosedSearchlist,
  putMMPLShortClosedSearchlist,
  getMMPLShipPendingSearchlist,
  mailCollectMDocSDoc,
  holdMailMdocSdoc,
  restorePo,
} from "../../Actions/MMPLDashboardAPI";
import MMPLPendingTaskPOValidation from "../MMPLPendingTaskPOValidation";
import MMPLPendingTaskMDocSDoc from "../MMPLPendingTaskMDocSDoc";
import MMPLPendingTaskIHM from "../MMPLPendingTaskIHM";
import MMPLShortClosed from "../MMPLShortClosed";
import DatePicker from "react-datepicker";
import Moment from "moment";
import CountUp from "react-countup";
import swal from "sweetalert";
import { confirmAlert } from "react-confirm-alert";
import API from "../../helpers/api";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import PO from "../../Asset/PO.svg";
import MyPendingTask from "../../Asset/MyPendingTask.svg";
import Awaiting from "../../Asset/Awaiting.svg";
import ShipPendingTask from "../../Asset/ShipPendingTask.svg";
import IHMPending from "../../Asset/IHMPending.svg";
import IHMUpdated from "../../Asset/IHMUpdated.svg";
import shortClosed from "../../Asset/shortClosed.svg";
import Ship from "../../Asset/Ship.svg";
import clear from "../../Asset/clear.svg";
import PoHistoryCardView from "./PoHistoryCardView";

class POSyncHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterTitle: "All Ships",
      showPendingTask: false,
      searchShip: {
        ShipName: "",
        PageSize: 25,
      },
      PageNo: 1,
      PgSize: 25,
      shipId: 0,
      TaskType: "poconfirmation",
      shipName: "",
      poValidationShipName: "",
      poNumber: "",
      mDocShipName: "",
      IHMShipName: "",
      ShortClosedShipName: "",
      poDescription: "",
      PODateFrom: "",
      PODateTo: "",
      itemDescription: "",
      supplierName: "",
      SelectedFromDate: "",
      SelectedToDate: "",
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      PendingTaskPO: true,
      PendingTaskMDocSDoc: false,
      isShipsPendingTask: false,
      PendingTaskIHM: false,
      isIhmUpdate2: false,
      TotalShip: false,
      PurchaseOrders: false,
      ShortClosed: false,
      posuccess: false,
      poHistoryList: [],
      poHistoryPagination: null,
    };
    this.SearchIHMShips = this.SearchIHMShips.bind(this);
    this.SearchPoValidationShips = this.SearchPoValidationShips.bind(this);
    this.SearchmDocShips = this.SearchmDocShips.bind(this);
    this.SearchShortClosedShips = this.SearchShortClosedShips.bind(this);
    this.SearchShips = this.SearchShips.bind(this);
    this.SearchPendingtask = this.SearchPendingtask.bind(this);
    this.ClearPurchaseOrderSearchField =
      this.ClearPurchaseOrderSearchField.bind(this);
    this.ClearPoSearchField = this.ClearPoSearchField.bind(this);
    this.ClearMdocSearchField = this.ClearMdocSearchField.bind(this);
    this.ClearIHMSearchField = this.ClearIHMSearchField.bind(this);
    this.ClearShortClosedSearchField =
      this.ClearShortClosedSearchField.bind(this);
    this.ClearShipSearchField = this.ClearShipSearchField.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handlePOInputChange = this.handlePOInputChange.bind(this);
    this.handleMdocInputChange = this.handleMdocInputChange.bind(this);
    this.handleIHMInputChange = this.handleIHMInputChange.bind(this);
    this.handleShortClosedInputChange =
      this.handleShortClosedInputChange.bind(this);
    this.handleShipInputChange = this.handleShipInputChange.bind(this);
    this.handlePONumberInputChange = this.handlePONumberInputChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.openFromDatePicker = this.openFromDatePicker.bind(this);
    this.openToDatePicker = this.openToDatePicker.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  componentDidMount() {
    const { dispatch, match, POSuccess } = this.props;
    dispatch({ type: "SubBannerTitle", data: "PO Sync History" });
    if (match.params.id) {
      this.setState({ shipId: match.params.id }, () => {
        this.fetchHistory(1);
      });
    }
  }

  fetchHistory = (pageNo) => {
    const params = {
      ShipId: this.state.shipId,
      DateFrom: this.state.PODateFrom || "",
      DateTo: this.state.PODateTo || "",
      PageNumber: pageNo,
      PageSize: this.state.PgSize,
    };
    axios
      .get(API.PoSyncHistory, { params })
      .then((response) => {
        const result = response.data || {};
        const data = result.data || [];
        const mapped = data.map((item) => ({
          poDate: item.syncDate,
          pulledPo: item.pulledPOsCount,
          IhmPresencePo: item.ihmPresencePOsCount,
          exceptions: item.totalExceptions,
        }));
        this.setState({
          poHistoryList: mapped,
          poHistoryPagination: result.pagination || null,
        });
      })
      .catch(() => {
        this.setState({ poHistoryList: [], poHistoryPagination: null });
      });
  };


  static getDerivedStateFromProps(nextProps, prevState) {
    const { dispatch, POSuccess } = nextProps;
    if (nextProps.isMDSearch && nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
    }
    if (nextProps.MDDeleteSuccess && !nextProps.showSidePane) {
      prevState.searchShip = nextProps.MDSearchData;
      dispatch(getMDSearchlist(prevState.searchShip));
    }
    if (POSuccess && !prevState.posuccess && POSuccess !== "") {
      prevState.poValidationShipName = POSuccess.poValidationShipName;
      prevState.mDocShipName = POSuccess.mDocShipName;
      prevState.IHMShipName = POSuccess.IHMShipName;
      prevState.ShortClosedShipName = POSuccess.ShortClosedShipName;
      prevState.poNumber = POSuccess.poNumber;
      prevState.poDescription = POSuccess.poDescription;
      prevState.supplierName = POSuccess.supplierName;
      prevState.itemDescription = POSuccess.itemDescription;
      prevState.PODateFrom = POSuccess.PODateFrom;
      prevState.PODateTo = POSuccess.PODateTo;
      prevState.PendingTaskPO = POSuccess.PendingTaskPO;
      prevState.PurchaseOrders = POSuccess.PurchaseOrders;
      prevState.isShipsPendingTask = POSuccess.isShipsPendingTask;
      prevState.PendingTaskMDocSDoc = POSuccess.PendingTaskMDocSDoc;
      prevState.PendingTaskIHM = POSuccess.PendingTaskIHM;
      prevState.isIhmUpdate2 = POSuccess.isIhmUpdate2;
      prevState.ShortClosed = POSuccess.ShortClosed;
      prevState.TaskType = POSuccess.TaskType;
      prevState.posuccess = true;
      // dispatch({ type: "POSuccess", data: ""});
    }
  }

  getClientDetails() {
    this.setState({ showClientDetails: true, filterShiplist: false });
  }

  SearchPendingtask() {
    this.setState({
      showPendingTask: true,
    });
  }

  ClearPurchaseOrderSearchField() {
    this.state.poValidationShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "purchaseorders";
    // this.props.dispatch(
    //   getMMPLPoValidationSearchlist(this.state, this.state.PageNo),
    // );
    this.setState({}, () => this.fetchHistory(1));
  }

  ClearPoSearchField() {
    this.state.poValidationShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "poconfirmation";
    // this.props.dispatch(
    //   getMMPLPoValidationSearchlist(this.state, this.state.PageNo),
    // );
    this.setState({}, () => this.fetchHistory(1));
  }

  ClearMdocSearchField() {
    this.state.mDocShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "collectmdocsdoc";
    this.props.dispatch(getMMPLMDocSearchlist(this.state, this.state.PageNo));
    this.setState({});
  }

  ClearIHMSearchField() {
    this.state.IHMShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "ihmpart1";
    this.props.dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
    this.setState({});
  }

  ClearShortClosedSearchField() {
    this.state.ShortClosedShipName = "";
    this.state.poNumber = "";
    this.state.poDescription = "";
    this.state.itemDescription = "";
    this.state.supplierName = "";
    this.state.PODateFrom = "";
    this.state.PODateTo = "";
    this.state.TaskType = "shortClosed";
    this.props.dispatch(
      getMMPLShortClosedSearchlist(this.state, this.state.PageNo),
    );
    this.setState({});
  }

  ClearShipSearchField() {
    this.state.shipName = "";
    this.props.dispatch(getMMPLShipSearch(this.state, this.state.PageNo));
    this.setState({});
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state[nodeName] = e.target.value;
    this.setState({});
  }

  handlePOInputChange(e) {
    this.state.poValidationShipName = e.target.value;
    this.setState({});
  }

  handleMdocInputChange(e) {
    this.state.mDocShipName = e.target.value;
    this.setState({});
  }

  handleIHMInputChange(e) {
    this.state.IHMShipName = e.target.value;
    this.setState({});
  }

  handleShortClosedInputChange(e) {
    this.state.ShortClosedShipName = e.target.value;
    this.setState({});
  }

  handleShipInputChange(e) {
    this.state.shipName = e.target.value;
    this.setState({});
  }

  handlePONumberInputChange(e) {
    this.state.poNumber = e.target.value;
    this.setState({});
  }

  handleFromDateChange(date) {
    this.state.PODateFrom = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD",
    );
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }

  handleToDateChange(date) {
    if (
      Moment(new Date(Date.parse(date))).format("YYYY-MM-DD") >=
      this.state.PODateFrom
    ) {
      this.state.PODateTo = Moment(new Date(Date.parse(date))).format(
        "YYYY-MM-DD",
      );
    } else {
      swal("Error!", "To date must be greater than from date ", "warning");
    }
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }

  openFromDatePicker() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
    });
  }

  openToDatePicker() {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  }

  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
    });
  }

  // handlePODateChange(date) {
  //   this.state.poDate = Moment(new Date(Date.parse(date))).format('YYYY-MM-DD');
  //   this.setState({
  //     SelectedPODate: date,
  //     poDatePickerIsOpen: false
  //   })
  // }

  // openPODatePicker() {
  //   this.setState({
  //     poDatePickerIsOpen: !this.state.poDatePickerIsOpen,
  //   });
  // };

  SearchPoValidationShips(PgNo) {
    const { dispatch } = this.props;
    // dispatch(getMMPLPoValidationSearchlist(this.state, PgNo));
    this.fetchHistory(PgNo);
  }

  SearchPoShip(PgNo) {
    const { dispatch } = this.props;
    // dispatch(getMMPLPoValidationSearchlist(this.state, PgNo));
    this.fetchHistory(PgNo);
  }

  SearchShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLShipSearch(this.state, PgNo));
  }

  SearchmDocShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLMDocSearchlist(this.state, PgNo));
  }

  SearchIHMShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLIHMSearchlist(this.state, PgNo));
  }

  SearchShortClosedShips(PgNo) {
    const { dispatch } = this.props;
    dispatch(getMMPLShortClosedSearchlist(this.state, PgNo));
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    // this.props.dispatch({ type: "POSuccess", data: "" });
  };

  confirmAll = (item) => {
    const { dispatch } = this.props;
    this.state.posuccess = false;
    this.setState({});
    let data = {
      purchaseOrderId: item.purchaseOrderId,
      isShortClosed: true,
    };
    dispatch(addMMPLShortClosedSearchlist(data, this.state));
  };

  //   undoShortClosed = (item) => {
  //     const { dispatch } = this.props;
  //     this.state.posuccess = false;
  //     let data = {
  //       purchaseOrderId: item.purchaseOrderId,
  //       isShortClosed: false
  //     }
  //     dispatch(putMMPLShortClosedSearchlist(data, this.state));
  //   };

  sendMail = (item) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let data = {
      purchaseOrderId: item.purchaseOrderId,
      sentReminderMail: true,
      userMail: user.email,
    };
    this.props.dispatch(mailCollectMDocSDoc(data, this.state));
  };

  HoldMail = (item) => {
    let data = {
      purchaseOrderId: item.purchaseOrderId,
      hold: item.isOnHold ? false : true,
    };
    this.props.dispatch(holdMailMdocSdoc(data, this.state));
  };
  revertPoItem = (shipId, poid) => {
    const { dispatch } = this.props;

    confirmAlert({
      message: "Are you sure want to revert this PO ?",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let url = `${API.RevertPo}` + poid;
            let url1 = url.replace(/\u200B/g, "");

            axios
              .put(url1)
              .then((response) => {
                console.log("tooSuceess");
                window.scrollTo(0, document.body.scrollHeight);
                dispatch(getMMPLShipCount(this.state.shipId));
                dispatch(getMMPLIHMSearchlist(this.state, this.state.PageNo));
                toast.success("Po Revert successfully.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((error) => { });
          },
        },
        {
          label: "No",
          onClick: () => { },
        },
      ],
    });
  };

  render() {
    const {
      shipMMPLInfo,
      equipmentInfo,
      MMPLSidePanCollectDocs,
      shipMMPLCount,
      MMPLShipList,
      poSearchResult,
      mDocSearchResults,
      IHMSearchResults,
      ShortClosedSearchResults,
      shipPendingResult,
    } = this.props;
    const {
      PendingTaskPO,
      PendingTaskMDocSDoc,
      PendingTaskIHM,
      isIhmUpdate2,
      TotalShip,
      PurchaseOrders,
      ShortClosed,
      isShipsPendingTask,
      poHistoryList,
      poHistoryPagination
    } = this.state;

    return (
      <div className="full-height pt-3">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mb-3"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
        </button>
        <>
          <div className="row my-3">
            <div className="col-lg-12">
              <div className="panel-box">
                <div
                  className="card MM-card-header m-auto"
                  style={{ backgroundColor: "white" }}
                >
                  <div className="card-body">
                    <h5
                      className="card-title ml-2 mt-2"
                      style={{ color: "092a51" }}
                    >
                      PO Sync History
                    </h5>
                  </div>
                </div>
                <div className="search-filter-box">
                  <div className="row" style={{ paddingBottom: "12px" }}>
                    {/* <div className="col-lg-3">
                                                <label className="form-label">Ship Name</label>
                                                <br></br>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="shipName"
                                                    placeholder="Ship Name"
                                                    onChange={(e) => this.handlePOInputChange(e)}
                                                    value={this.state.poValidationShipName}
                                                ></input>
                                            </div> */}
                    <div className="col-lg-3">
                      <label className="form-label">Date From</label>
                      <div
                        className="input-group add-on date datepicker"
                        data-date-format="yyyy-mm-dd"
                      >
                        <input
                          type="text"
                          value={this.state.PODateFrom}
                          className="form-control date-picker"
                          placeholder="PO Date From"
                          name="POFromDate"
                        ></input>
                        <DatePicker
                          selected={this.state.SelectedFromDate}
                          onChange={this.handleFromDateChange}
                          open={this.state.fromDatePickerIsOpen}
                          onClickOutside={this.handleBlur}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date"
                        />
                        <div
                          className="input-group-btn calendar-icon"
                          onClick={this.openFromDatePicker}
                        >
                          <button className="btn btn-default">
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3">
                      <label className="form-label">Date To</label>
                      <div
                        className="input-group add-on date datepicker"
                        data-date-format="yyyy-mm-dd"
                      >
                        <input
                          value={this.state.PODateTo}
                          type="text"
                          placeholder="PO Date To"
                          className="form-control date-picker"
                          name="POToDate"
                          data-date-format="yyyy-mm-dd"
                        />
                        <DatePicker
                          selected={this.state.SelectedToDate}
                          onChange={this.handleToDateChange}
                          open={this.state.toDatePickerIsOpen}
                          onClickOutside={this.handleBlur}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date"
                        />
                        <div className="input-group-btn calendar-icon">
                          <button
                            className="btn btn-default"
                            onClick={this.openToDatePicker}
                          >
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label"></label>
                      <br></br>
                      <div
                        className="mt-3 search-btn-col"
                        style={{ textAlign: "end" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.SearchPoShip(1)}
                        >
                          {" "}
                          Search{" "}
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.ClearPurchaseOrderSearchField()}
                        >
                          {" "}
                          Clear{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {poHistoryList ? (
            <div id="textbody">
              <PoHistoryCardView
                arraylist={poHistoryList}
                pageSize={poHistoryPagination?.pageSize || 0}
                totalRecords={poHistoryPagination?.totalcount || 0}
                setUpdatedState={(value) => this.SearchPoShip(value)}
                PO={PurchaseOrders}
                confirmAll={(item) => this.confirmAll(item)}
              />
            </div>
          ) : null}
        </>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    arraylist: state.SidePanReducer.arraylist,
    MDDeleteSuccess: state.SidePanReducer.MDDeleteSuccess,
    isMDSearch: state.SidePanReducer.isMDSearch,
    MDSearchData: state.SidePanReducer.MDSearchData,
    ClientShipDetails: state.SidePanReducer.ClientShipDetails,
    //BY BALU MOORTHI
    shipMMPLCount: state.MMPLDashboardReducer.ShipMMPLCount,
    shipMMPLDetail: state.MMPLDashboardReducer.shipMMPLDetail || {},
    shipMMPLSearchResult: state.MMPLDashboardReducer.MMPLShipSearchResult || [],
    shipMMPLInfo: state.MMPLDashboardReducer.MMPLShipInfo || {},
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    MMPLSidePanCollectDocs: state.MMPLDashboardReducer.MMPLSidePanCollectDocs,
    MMPLShipList: state.MMPLDashboardReducer.MMPLShipList,
    poSearchResult: state.MMPLDashboardReducer.MMPLPOShipSearchResult,
    shipPendingResult: state.MMPLDashboardReducer.MMPLPOShipPendingResult,
    mDocSearchResults: state.MMPLDashboardReducer.MMPLMdocShipSearchResult,
    IHMSearchResults: state.MMPLDashboardReducer.MMPLIHMShipSearchResult,
    ShortClosedSearchResults:
      state.MMPLDashboardReducer.MMPLShortClosedShipSearchResult,
    POSuccess: state.MMPLDashboardReducer.POSuccess,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(POSyncHistory);
